export const BRANDING = {
  logoUrl: process.env.REACT_APP_LOGO_URL || "/ChiefAhtahkakoopLogo.png",
  watermark: {
    enabled: true,
    opacity: 0.08,
    sizeVw: 40,
    position: "center",
  },
};
